import { Container, Typography } from "@mui/material";
import TemplateForm from "../../components/templates/TemplateForm/Form";
import { useNavigate } from "react-router-dom";

const NewTemplatePage = () => {
  const navigate = useNavigate();

  const handleSuccess = () => {
    navigate("/dashboard/templates"); // Redirige después de crear
  };

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Typography variant="h4" gutterBottom sx={{ mb: 4 }}>
        Nueva Plantilla
      </Typography>
      <TemplateForm onSuccess={handleSuccess} />
    </Container>
  );
};

export default NewTemplatePage;
